import React from 'react';
import styled from 'styled-components';
import { TrevorComponent } from '@trevor/ui-components';
import { SavedQueriesWidget } from '@/features/savedQueriesWidget/SavedQueriesWidget';
import { DASHBOARD_WIDGET_CONFIGURATION } from '@/features/savedQueriesWidget/widgetRenderContext.constants';
import {
  SavedQueriesList,
  ScrollContainer,
  SearchControlsContainer,
  SearchTermContainer,
} from '@/features/savedQueriesWidget/styled-components';
import { SavedQuery } from '@/types';
import {
  selectChartWidgetIndex,
  selectedChartWidget,
  selectWidget,
} from '@/features/dashboard/dashboardSlice';
import ViewRef from '@/util/ViewRef';
import { SELECT_SAVED_QUERY_FOR_WIDGET } from '@/actions/constants';
import { useAppDispatch, useAppSelector } from '@/store/hooks';

const _SavedQuerySelect: TrevorComponent = ({ className }) => {
  const dispatch = useAppDispatch();
  const index = useAppSelector(selectChartWidgetIndex);
  const widget = useAppSelector(selectedChartWidget)!;
  const handleSavedQuerySelect = (savedQuery: SavedQuery) => {
    dispatch(
      selectWidget({
        selectedChartWidgetIndex: index!,
        displayType: 'table',
        view: ViewRef.fromSavedQuery(savedQuery),
        widget,
      }),
    );
    dispatch({
      type: SELECT_SAVED_QUERY_FOR_WIDGET,
      payload: {
        view: ViewRef.fromSavedQuery(savedQuery),
        widgetIndex: index,
      },
    });
  };

  return (
    <div className={className}>
      <SavedQueriesWidget
        onSelectQuery={handleSavedQuerySelect}
        mode={DASHBOARD_WIDGET_CONFIGURATION}
      />
    </div>
  );
};

export const SavedQuerySelect = styled(_SavedQuerySelect)`
  width: 100%;

  ${ScrollContainer} {
    max-height: ${window.innerHeight - 232}px;
    border: 1px solid #ccc;
    border-radius: var(--radius-4);
  }

  ${SavedQueriesList} {
    width: 100%;
  }

  ${SearchTermContainer} {
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 16px;
  }

  ${SearchControlsContainer} {
    width: 100%;
    & > div {
      margin-left: auto;
    }
  }
`;
